
const BASE_URL = 'https://app.dev.pragathirail.ai';
const AUTH_BASE_URL = 'https://dev.auth.pragathirail.ai';

export const environment = {
  production: false,
  urlMapping: {
    PROJ_API: `${BASE_URL}/`,
    PROJ_API_URL: `${BASE_URL}/api`,
    PROJ_API_V1_URL: `${BASE_URL}/api/v1`,
    SSE_URL: '',
    USERMGMT_API: `${AUTH_BASE_URL}/um/`,
    DOMAIN_URL: `${BASE_URL}/`
  },
  KEYCLOAK_URLS: {
    BASE_URL: `${AUTH_BASE_URL}/auth`,
    REDIRECT_URL: `${BASE_URL}/digital-library`,
    LOGOUT_URL: `${BASE_URL}/login`
  },
  YOLO_CALLBACK_URL: '',
  CLIENT_ID: 'pragathirailusermgmt',
  REALM_NAME: 'pragathi-rail-um'
};
